enum MediaQueries  {
    SM_MIN = '481px',
    MD_MIN = '769px',
    LG_MIN = '1025px',
    XL_MIN = '1201px',
}

export default MediaQueries;